<template>
    <v-card>
        <!-- Toolbar -->
        <v-toolbar
            dark
            color="primary"
        >
            <v-btn
                icon
                dark
                @click="$emit('update:show', false)"
                :disabled="isSaving"
            >
                <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>
                {{ title }}
            </v-toolbar-title>
            <v-spacer />
            <v-toolbar-items
                v-if="$vuetify.breakpoint.smAndDown"
            >
                <!-- Save Button -->
                <v-btn
                    dark
                    text
                    :loading="isSaving"
                    :disabled="isSaving"
                    @click="onSubmit"
                >
                    Save
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <!-- Form -->
        <v-card-text>
            <v-form
                class="my-3"
                ref="form"
                @submit.prevent="onSubmit"
            >
                <draggable
                    v-model="linksCopy"
                    handle=".handler"
                    v-bind="dragOptions"
                    @start="drag = true"
                    @end="drag = false"
                >
                    <transition-group
                        type="transition"
                        :name="!drag ? 'flip-list' : null"
                        tag="div"
                    >
                        <div
                            class="mb-2 sortable handler"
                            v-for="item in linksCopy"
                            :key="item.id"
                        >
                            <v-icon>
                                reorder
                            </v-icon>
                            <link-button
                                :link="item"
                                disable-link
                                disable-tooltip
                                text-only
                                max-width="calc(100% - 24px)"
                            />
                        </div>
                    </transition-group>
                </draggable>
            </v-form>
        </v-card-text>
        <v-card-actions
            v-if="$vuetify.breakpoint.mdAndUp"
        >
            <v-spacer />
            <v-btn
                text
                @click="$emit('update:show', false)"
            >
                Cancel
            </v-btn>
            <v-btn
                @click="onSubmit"
                color="primary"
                :loading="isSaving"
                :disabled="isSaving"
            >
                Save
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import LinkButton from './LinkButton'
import draggable from 'vuedraggable'

export default {
    components: {
        LinkButton,
        draggable
    },

    data () {
        return {
            linksCopy: [],
            drag: false,
            dragOptions: {
                animation: 200,
                ghostClass: 'ghost'
            }
        }
    },

    props: {
        title: {
            type: String,
            required: true
        },
        show: {
            type: Boolean,
            required: true
        },
        links: {
            type: Array,
            default: () => ([])
        },
        isSaving: {
            type: Boolean,
            default: false
        }
    },

    watch: {
        links: {
            immediate: true,
            handler: function (val) {
                this.linksCopy = [...val]
            }
        }
    },

    methods: {
        onSubmit () {
            this.$emit('submit', [...this.linksCopy])
        }
    }
}
</script>

<style scoped lang="scss">
.sortable {
    background-color: #fff;
}
.handler {
    cursor: move;
}
.ghost {
    background-color: var(--v-secondary-base);
    opacity: 0.5;
    ::v-deep.v-icon, ::v-deep.button-text {
        color: #fff;
    }
}
</style>
